var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelephone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20.031,
    viewBox: "0 0 24 20.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone",
    transform: "translate(-552.014 -649.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M569.5,670h-11c-.113,0-2.438-.742-2.565-1.423a17.785,17.785,0,0,1-.291-3.315l2.383-6.925A.5.5,0,0,1,558.5,658h11a.5.5,0,0,1,.467.32l2.679,6.955a1.286,1.286,0,0,1,.093.646c-.047.43-.179,1.551-.389,2.656a1.19,1.19,0,0,1-.689.767A13.22,13.22,0,0,1,569.5,670Zm-10.933-1H569.5c.027-.019.963-.316,1.8-.586,0,0,.072-.056.091-.082.18-1.012.309-2.1.355-2.52a.3.3,0,0,0-.024-.157L569.157,659h-10.3l-2.282,6.626c0,.169.2,1.891.318,2.62A12.2,12.2,0,0,0,558.567,669Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M564.169,667.7c-2.346,0-4.255-1.617-4.255-3.6s1.909-3.6,4.255-3.6,4.256,1.616,4.256,3.6S566.516,667.7,564.169,667.7Zm0-6.207c-1.795,0-3.255,1.168-3.255,2.6s1.46,2.6,3.255,2.6,3.256-1.168,3.256-2.6S565.965,661.489,564.169,661.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M573.269,658.383a1.522,1.522,0,0,1-.715-.181,16.7,16.7,0,0,0-2.507-1.17,1.336,1.336,0,0,1-.914-1.545l.2-.742a.482.482,0,0,0-.052-.362c-.319-.429-3.142-.776-5.265-.776-2.047,0-4.809.364-5.114.789a.476.476,0,0,0-.051.364l.2.74a1.335,1.335,0,0,1-.913,1.546c-.57.2-1.443.572-2.144.875-1,.431-1.079.461-1.231.461a1.243,1.243,0,0,1-1.068-.543l-1.531-2.4a.985.985,0,0,1-.109-.787,2.016,2.016,0,0,1,.869-1.057,19.879,19.879,0,0,1,11.095-3.621,20.593,20.593,0,0,1,11.086,3.615,1.994,1.994,0,0,1,.877,1.062h0a.979.979,0,0,1-.107.786l-1.532,2.405A1.26,1.26,0,0,1,573.269,658.383Zm-9.255-7.414a19.1,19.1,0,0,0-10.508,3.431c-.121.088-.442.32-.487.5l1.511,2.4a.233.233,0,0,0,.171.083c.153-.054.486-.2.891-.376.718-.31,1.61-.7,2.216-.9.193-.067.3-.238.271-.349l-.2-.735a1.478,1.478,0,0,1,.161-1.137c.751-1.257,5.757-1.272,5.97-1.272.549,0,5.392.036,6.123,1.262A1.476,1.476,0,0,1,570.3,655l-.18.675a.345.345,0,0,0,.255.409,17.248,17.248,0,0,1,2.594,1.2c.245.131.47.1.531.008,0-.005.108-.171,1.532-2.406l.464-.12-.484.125c-.023-.088-.125-.244-.479-.49A19.829,19.829,0,0,0,564.014,650.969Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M561.5,659a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,561.5,659Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M567.5,659a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,1,0v2A.5.5,0,0,1,567.5,659Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelephone);
export default __webpack_public_path__ + "static/media/icon_telephone.39fd8b4db09da9870d80add5a0027be1.svg";
export { ForwardRef as ReactComponent };